__turbopack_context__.v({
  "pill": "_7bPAHG_pill",
  "pillActive": "_7bPAHG_pillActive",
  "pillLight": "_7bPAHG_pillLight",
  "pillNoMargin": "_7bPAHG_pillNoMargin",
});
